import React from "react";
import { any, shape, string } from "prop-types";
import * as R from "ramda";
import useFetchJson from "../../common/useFetchJson.js";
import useScrollRestoration from "../../common/useScrollRestoration.js";
import useSearchValues from "../../common/routing/useSearchValues.js";
import { getOffsetTop } from "../../common/scrollHelpers.js";
import { getCurrentResultsRange } from "../Pagination/pagerMath.js";

import Pagination from "../Pagination/Pagination.jsx";
import UnitList from "./UnitList.jsx";

const propTypes = {
  scrollToRef: shape({
    current: any,
  }),
  unitListingTitle: string,
};

const UnitListContainer = props => {
  const { scrollToRef, unitListingTitle } = props;

  useScrollRestoration();

  // query string will include other search values, like bedrooms, etc
  const { getLocationFor, apiQueryString } = useSearchValues();

  const url = `/api/v1/units${apiQueryString}`;

  const unitsResponse = useFetchJson(url, { method: "GET" });

  const {
    currentPage = 0,
    items,
    perPage = 1,
    totalCount = 0,
    sightmapEmbedId = null,
  } = unitsResponse.data || {};

  if (unitsResponse.error) {
    console.error(unitsResponse.error);
    return "There was an error loading the page, please try again later";
  }

  const resultsRangeText = getCurrentResultsRange({
    currentPage: currentPage + 1,
    perPage,
    totalResults: totalCount,
  });

  return (
    <UnitList
      isLoading={unitsResponse.isLoading}
      // isLoading={true}
      units={items || []}
      // units={[]}
      title={unitListingTitle}
      resultsRange={
        totalCount > 0 ? `${resultsRangeText} of ${totalCount}` : null
      }
      hasSightmap={!R.isNil(sightmapEmbedId)}
      pagination={
        totalCount > 0 && (
          <Pagination
            currentPage={currentPage + 1}
            totalPages={Math.ceil(totalCount / perPage)}
            getLocationFor={page => getLocationFor({ page })}
            onPageChange={page => {
              window.scrollTo(0, getOffsetTop(scrollToRef.current));
            }}
          />
        )
      }
    />
  );
};

UnitListContainer.propTypes = propTypes;
export default UnitListContainer;
